module.exports = __webpack_public_path__ + "img/IMG_8995.f99cb719.jpg";